// src/NumberContext.js   -> Total Students Count Provider
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';


const NumberContext = createContext();

export function NumberProvider({ children }) {
  const [totalStudent, setTotalStudent] = useState([]);
  const [loading, setLoading] = useState(false);

  
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.apiBaseUrl}/students/get/getTotalStudent.php`);
      const data = await response.json();
      setTotalStudent(data);
    } catch (error) {
      console.error('Error fetching fee totalStudent data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refetchStudentCount = () => {
    fetchData();
  };

  console.log(totalStudent);

  return (
    <NumberContext.Provider value={{ totalStudent, loading, refetchStudentCount }}>
      {children}
    </NumberContext.Provider>
  );
}

export function useStudentCount() {
  const context = useContext(NumberContext);
  if (context === undefined) {
    throw new Error('useStudentCount must be used within a NumberProvider');
  }
  return context;
}
